
<template>
  <div class="feedback">
    <div class="modal fade" id="trialModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <!-- 加载状态 -->
          <div id="my_feedback_load" v-show="isLoading">
            <div
              class="modal_load_div d-flex justify-content-center align-items-center"
            >
              <div class="spinner-border modal_load" role="status"></div>
            </div>
          </div>

          <div class="modal-header">
            <h1 class="modal-title title">
              {{ $t("pp_services.trial.title") }}
            </h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body modal-dialog-scrollable">
            <form class="formData" id="feedback_formData">
              <!-- 邮箱 -->
              <div class="form-content form_input captcha">
                <input
                  type="email"
                  id="feedback_EmailAddress"
                  v-model="form.EmailAddress"
                  name="EmailAddress"
                  maxlength="100"
                  :placeholder="`${$t(
                    'pp_services.trial.form_emailAddress'
                  )}（${$t('pp_services.trial.Required')}）`"
                  :class="{ selected: errors.EmailAddress }"
                  @blur="validateField('EmailAddress')"
                  @change="validateField('EmailAddress')"
                />
                <div
                  id="feedback_emailMsg"
                  class="pop-tips"
                  v-show="errors.EmailAddress"
                >
                  *{{ $t("pp_services.trial.form_tip1") }}
                </div>
              </div>
              <!-- 公司名称 -->
              <div class="form-content">
                <input
                  type="text"
                  id="feedback_CompanyName"
                  v-model="form.CompanyName"
                  name="CompanyName"
                  maxlength="200"
                  :placeholder="`${$t(
                    'pp_services.trial.form_companyName'
                  )}（${$t('pp_services.trial.Required')}）`"
                  :class="{ selected: errors.CompanyName }"
                  @blur="validateField('CompanyName')"
                  @change="validateField('CompanyName')"
                />
                <div
                  id="feedback_companyMsg"
                  class="pop-tips"
                  v-show="errors.CompanyName"
                >
                  *{{ $t("pp_services.trial.Required") }}
                </div>
              </div>
              <!-- 姓名 -->
              <div class="form-content">
                <input
                  type="text"
                  id="feedback_FullName"
                  v-model="form.FullName"
                  name="FullName"
                  maxlength="100"
                  :placeholder="$t('pp_services.trial.form_fullname')"
                  :class="{ selected: errors.FullName }"
                  @blur="validateField('FullName')"
                  @change="validateField('FullName')"
                />
              </div>

              <!-- <div class="combination"> -->
              <!-- 联系电话 -->
              <div class="form-content form_input">
                <input
                  type="tel"
                  id="feedback_Telephone"
                  v-model="form.Telephone"
                  name="Telephone"
                  maxlength="100"
                  :placeholder="$t('pp_services.trial.form_telephone')"
                  :class="{ selected: errors.Telephone }"
                  @blur="validateField('Telephone')"
                  @change="validateField('Telephone')"
                />
              </div>

              <!-- </div> -->

              <div class="combination">
                <!-- 验证码 -->
                <div class="form-content form_input captcha pr--15">
                  <input
                    type="text"
                    id="feedback_captcha"
                    v-model="form.captcha"
                    name="captcha"
                    :placeholder="$t('pp_services.trial.form_captcha')"
                    :class="{ selected: errors.captcha }"
                    @blur="validateField('captcha')"
                    @change="validateField('captcha')"
                    @input="validateField('captcha')"
                  />
                  <div
                    id="feedback_captchaMsg"
                    class="pop-tips"
                    v-show="errors.captcha"
                  >
                    *{{ $t("pp_services.trial.form_tip2") }}
                  </div>
                </div>

                <!-- 验证码图片 -->
                <div class="form-content form_input pl--15">
                  <Identity
                    v-if="codeFlag"
                    @getIdentifyCode="getIdentifyCode"
                  />
                </div>
              </div>
            </form>
          </div>

          <!-- 提交按钮 -->
          <div class="form-content" id="feedback_pop-btn">
            <button
              type="button"
              class="form_btn"
              id="feedback_popBtn"
              @click="submitFeedbackForm"
              :disabled="isLoading"
            >
              {{ $t("pp_services.trial.form_btn") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 成功提示 -->
    <div
      aria-live="polite"
      aria-atomic="true"
      class="d-flex justify-content-end align-items-center p-3 w-100 feedback_toast"
    >
      <div
        id="my_feedback_toast"
        class="toast"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        data-bs-delay="3000"
      >
        <div class="d-flex">
          <div class="toast-body text_color">
            {{ $t("pp_services.trial.form_success") }}
          </div>
          <button
            type="button"
            class="btn-close me-2 m-auto"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal, Toast } from "bootstrap";
import Identity from "@/components/elements/identity/Identity";
import { createBus } from "@/helpers/api";

export default {
  name: "FreeTrial",
  components: {
    Identity,
  },

  data() {
    return {
      bsModal: null, // 模态框实例
      isLoading: false, // 提交按钮加载状态
      codeFlag: false, // 加载验证码标识
      saveCaptcha: "", // 图形验证码
      hideModalHandler: null, // 存储事件监听器引用
      showModalHandler: null, // 存储事件监听器引用
      // 表单数据
      form: {
        FullName: "", // 姓名
        Telephone: "", // 联系电话
        EmailAddress: "", // 电子邮箱
        captcha: "", // 图形验证码
        CompanyName: "", // 公司全称
      },
      // 错误状态
      errors: {
        FullName: false,
        Telephone: false,
        EmailAddress: false,
        captcha: false,
        CompanyName: false,
      },
    };
  },

  mounted() {
    // 初始化模态框
    this.initModal();
  },

  methods: {
    // 初始化模态框
    initModal() {
      this.bsModal = new Modal("#trialModal");
      const modalEl = document.getElementById("trialModal");

      // 存储事件监听器函数引用，以便后续移除
      this.hideModalHandler = () => {
        this.clearForm();
      };
      this.showModalHandler = () => {
        this.codeFlag = true;
      };

      // 绑定模态框事件
      modalEl.addEventListener("hide.bs.modal", this.hideModalHandler);
      modalEl.addEventListener("show.bs.modal", this.showModalHandler);
    },

    // 获取图形验证码
    getIdentifyCode(captcha) {
      this.saveCaptcha = captcha;
    },

    // 验证单个字段
    validateField(fieldName) {
      // 重置该字段的错误状态
      this.errors[fieldName] = false;

      // 根据字段名进行不同的验证
      switch (fieldName) {
        case "CompanyName":
          // 必填字段验证
          this.errors[fieldName] = !this.form[fieldName];
          return !this.errors[fieldName];

        case "EmailAddress":
          // 邮箱必填且格式验证
          if (!this.form.EmailAddress) {
            this.errors.EmailAddress = true;
          } else {
            const regEmail =
              /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/;
            this.errors.EmailAddress = !regEmail.test(this.form.EmailAddress);
          }
          return !this.errors[fieldName];

        case "Telephone":
          // 电话号码格式验证 (可以为空，但不为空时需符合格式)
          if (
            this.form.Telephone &&
            !/^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,4}[-\s.]?[0-9]{1,9}$/.test(
              this.form.Telephone
            )
          ) {
            this.errors.Telephone = true;
          }
          return !this.errors[fieldName];

        case "captcha":
          // 验证码验证
          if (this.form.captcha) {
            this.errors.captcha = this.form.captcha !== this.saveCaptcha;
          } else {
            this.errors.captcha = true;
          }
          return !this.errors[fieldName];

        default:
          return true;
      }
    },

    // 验证整个表单
    validateForm() {
      // 重置所有错误状态
      Object.keys(this.errors).forEach((key) => {
        this.errors[key] = false;
      });

      // 验证必填字段
      let isValid = true;

      // 验证电话 (格式验证，非必填)
      this.validateField("Telephone");
      if (this.errors.Telephone) {
        isValid = false;
      }

      // 验证邮箱 (必填)
      if (!this.validateField("EmailAddress")) {
        isValid = false;
      }

      // 验证公司名称 (必填)
      if (!this.validateField("CompanyName")) {
        isValid = false;
      }

      // 验证验证码 - 调用validateField进行完整验证，包括必填性和正确性
      if (this.codeFlag) {
        if (!this.validateField("captcha")) {
          isValid = false;
        }
      }

      return isValid;
    },

    async submitFeedbackForm() {
      // 验证表单
      const isValid = this.validateForm();
      if (!isValid) {
        return;
      }
      // 准备提交数据
      const submitData = {
        FullName: this.form.FullName,
        Telephone: this.form.Telephone,
        CompanyName: this.form.CompanyName,
        CompanyLocation: "",
        EmailAddress: this.form.EmailAddress,
        CustomerIndustry: 0,
        CustomerIndustryName: "",
        CustomerBudget: 0,
        CustomerBudgetName: "",
        ConsultDetails: "审批工作流试用申请",
        ProcessStatus: 10, // 待处理状态
        ProcessDesc: "",
      };

      try {
        // 显示加载状态
        this.isLoading = true;
        // 提交数据
        const res = await createBus(submitData);

        this.isLoading = false;

        if (res && res.state === "success") {
          // 关闭模态框并显示成功提示
          this.bsModal.hide();
          this.showSuccessToast();
        } else {
          console.error("提交失败:", res?.message || "未知错误");
        }
      } catch (error) {
        console.error("提交表单失败:", error);
        this.isLoading = false;
      }
    },

    // 清空表单数据和错误状态
    clearForm() {
      this.codeFlag = false;
      this.isLoading = false;

      // 重置表单数据
      Object.keys(this.form).forEach((key) => {
        this.form[key] = "";
      });

      // 重置错误状态
      Object.keys(this.errors).forEach((key) => {
        this.errors[key] = false;
      });
    },

    // 组件销毁时清理
    beforeUnmount() {
      if (this.bsModal) {
        const modalEl = document.getElementById("trialModal");
        if (modalEl) {
          // 使用相同的函数引用移除事件监听器
          modalEl.removeEventListener("hide.bs.modal", this.hideModalHandler);
          modalEl.removeEventListener("show.bs.modal", this.showModalHandler);
        }
        // 销毁模态框
        this.bsModal.dispose();
      }
    },

    // 显示成功提示
    showSuccessToast() {
      // 获取所有匹配的元素并创建 Toast 实例
      const toastElements = document.querySelectorAll("#my_feedback_toast");
      const toastList = [];

      // 创建 Toast 实例列表
      toastElements.forEach((element) => {
        toastList.push(new Toast(element));
      });

      // 显示所有 Toast
      toastList.forEach((toast) => {
        toast.show();
      });
    },
  },
};
</script>
